import { useContext } from 'react';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const IsAmpActiveTabRequestEnabledConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Amp Active Tab Request"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Amp Active Tab Request']}
				description="Enable or disable the Amp Active Tab Request feature"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid item xs={6}>
				<CheckboxInput
					keyData={keyData}
					label="Enabled"
					disabled={false}
					defaultChecked={false}
					containerStyles={{ marginTop: '6rem', marginLeft: '4.5rem', width: 'fit-content' }}
					object={rawConfig}
					updateObject={updateRawConfig}
				/>
			</Grid>
		</Paper>
	);
};
export default IsAmpActiveTabRequestEnabledConfig;
